import { useSearchParams } from "react-router";
import { PersonaDetail } from "./components/persona/PersonaDetail.tsx";
import { CreatePersona } from "./components/persona/CreatePersona.tsx";
import { CampaignWrapper } from "./components/campaign/CampaignWrapper.tsx";
import { CreatorOverview } from "./components/creator/CreatorOverview.tsx";

export const GlobalSlideouts = () => {
  const [searchParams, setSearchParams] = useSearchParams();

  const personaId = searchParams.get("personaId");
  const createPersona = searchParams.get("createPersona");
  const campaignId = searchParams.get("campaignId");
  const creatorId = searchParams.get("creatorId");
  const creatorIdMenu = searchParams.get("menu");

  const closeDrawer = (param: string) => {
    const newParams = new URLSearchParams(searchParams);
    newParams.delete(param);
    setSearchParams(newParams, { replace: true });
  };

  return (
    <>
      <PersonaDetail
        personaId={personaId}
        setIsOpen={() => closeDrawer("personaId")}
      />
      <CreatePersona
        isOpen={!!createPersona}
        setIsOpen={() => closeDrawer("createPersona")}
      />
      <CampaignWrapper
        campaignId={campaignId}
        setIsOpen={() => closeDrawer("campaignId")}
      />
      <CreatorOverview
        creatorId={creatorId}
        setIsOpen={() => closeDrawer("creatorId")}
        menu={creatorIdMenu}
      />
    </>
  );
};
